export const ensureInteger = value => {
    if (typeof value !== 'number' && typeof value !== 'string') return undefined;
    const n = +value;
    return Number.isInteger(n) ? n : undefined;
};

export const makeLabel = (label, required) => {
    if (required && label) {
        return label + ' *';
    }
    return label ?? '';
}

export const validateOptions = (options, label, value) => {
    if (!Array.isArray(options)) {
        throw new Error("options must be an array");
    }
    if (options.some(o => typeof o === 'object') && !options.every(o => typeof o === 'object')) {
        throw new Error("options cannot have mixed primitive and object types");
    }
    if (typeof options[0] === 'object') {
        if (!value || !label) {
            throw new Error("label and value fields must be specified if options are a list of objects");
        }
        if (!options.every(o => o.hasOwnProperty(value) && o.hasOwnProperty(label))) {
            throw new Error("all options must contain the specified label and value fields");
        }
    }
}

export const decodeJWT = (token) => {
    const urlBase64Decode = (str) => {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        while (output % 4) {
            output += '='
        }
        return window.atob(output);
    }

    const parts = token.split('.');
    
    if (parts.length !== 3) {
        throw new Error('JWT must have 3 parts');
    }
    
    const decoded = urlBase64Decode(parts[1]);
    if (!decoded) {
        throw new Error('Cannot decode the token');
    }
    
    return JSON.parse(decoded);
};

export const getSelector = def => {
    let selector = def.uuid ?? def.field ?? def.title;
    if (Array.isArray(selector)) {
        if (selector.every(s => typeof s === 'string')) {
            selector = selector[0];
        } else {
            selector = selector.find(s => s.dest === 'value')?.src ?? selector[0].src;
        }
    } else if (typeof selector === 'object') {
        selector = Object.values(selector)[0];
    }
    if (typeof selector !== 'string') {
        throw new Error('Non-string selector ' + JSON.stringify(selector));
    }
    return selector;
}